import type { AudioBusId } from "../ports/types";

/** The bus a sound plays on, from its asset category. */
export function resolveBus(category: string): AudioBusId {
  if (category === "music") return "music";
  if (category === "ui") return "ui";
  if (category === "voice") return "voice";
  if (category === "ambient") return "ambient";
  return "sfx";
}

/** A valid gain, or undefined for "the engine's default". */
export function resolveGain(g: number | undefined): number | undefined {
  if (typeof g !== "number" || !Number.isFinite(g) || g < 0) return undefined;
  return g;
}
